import { render, staticRenderFns } from "./CustomerDocuments.vue?vue&type=template&id=653d6702"
import script from "./CustomerDocuments.vue?vue&type=script&lang=js"
export * from "./CustomerDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports